(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity-payout/assets/react/hooks/use-charity-payout.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity-payout/assets/react/hooks/use-charity-payout.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useEffect
} = React;
const {
  useAtom,
  useAtomValue,
  useSetAtom
} = jotai;
const {
  selectedResultAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  charityPayoutsAtom,
  charityPayoutChartAtom
} = svs.lyckoplatsen.shared_charity_payout.jotai.atoms;
const {
  fetchCharityPayouts
} = svs.lyckoplatsen.components.shared_charity.api_calls;
const memoFetchCharityPayouts = _.memoize(fetchCharityPayouts);
const {
  PAYOUT_KEYS
} = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const {
  logger
} = svs.lyckoplatsen;
const useCharityPayout = () => {
  const [charityPayouts, setCharityPayouts] = useAtom(charityPayoutsAtom);
  const setPayoutChartData = useSetAtom(charityPayoutChartAtom);
  const selectedResult = useAtomValue(selectedResultAtom);
  const selectedDrawNumber = selectedResult === null || selectedResult === void 0 ? void 0 : selectedResult.drawNumber;
  const handler = async () => {
    var _charityPayouts$PAYOU;
    if (selectedDrawNumber === charityPayouts.latestDraw.drawId) {
      setPayoutChartData(charityPayouts.latestDraw.data);
      return handler;
    }
    if ((_charityPayouts$PAYOU = charityPayouts[PAYOUT_KEYS.SPECIFIC_DRAWS]) !== null && _charityPayouts$PAYOU !== void 0 && _charityPayouts$PAYOU[selectedDrawNumber]) {
      var _charityPayouts$PAYOU2;
      setPayoutChartData((_charityPayouts$PAYOU2 = charityPayouts[PAYOUT_KEYS.SPECIFIC_DRAWS]) === null || _charityPayouts$PAYOU2 === void 0 ? void 0 : _charityPayouts$PAYOU2[selectedDrawNumber]);
      return handler;
    }
    try {
      const fetchedDates = await memoFetchCharityPayouts(null, selectedDrawNumber);
      const data = fetchedDates.response.payoutStatistics[PAYOUT_KEYS.SPECIFIC_DRAWS][0].data;
      const newObject = _objectSpread(_objectSpread({}, charityPayouts), {}, {
        [PAYOUT_KEYS.SPECIFIC_DRAWS]: _objectSpread(_objectSpread({}, charityPayouts[PAYOUT_KEYS.SPECIFIC_DRAWS]), {}, {
          [selectedDrawNumber]: data
        })
      });
      setPayoutChartData(data);
      setCharityPayouts(newObject);
    } catch (error) {
      logger.error('Failed to fetch charity payouts', error);
      setPayoutChartData(null);
    }
  };
  useEffect(() => {
    handler();
  }, [selectedResult]);
};
setGlobal('svs.lyckoplatsen.components.shared_charity_payout.react.hooks', {
  useCharityPayout
});

 })(window);